import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../lib/api';
import { Dialog, DialogContent, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { BadgeShield, badgeTier } from './BadgeShield';

const COLORS = ['#F37021', '#002B47', '#F2B632', '#B8C3CE', '#C98A4B'];
const Confetti = () => (
  <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden>
    {Array.from({ length: 28 }).map((_, i) => (
      <span key={i} className="absolute top-[-10%] w-2 h-3 rounded-sm" style={{ left: `${(i * 37) % 100}%`, background: COLORS[i % 5],
        animation: `confetti-fall ${1.6 + (i % 5) * 0.3}s ${(i % 7) * 0.12}s ease-in forwards`, transform: `rotate(${i * 25}deg)` }} />
    ))}
    <style>{`@keyframes confetti-fall{to{transform:translateY(520px) rotate(540deg);opacity:0}}@keyframes badge-pop{0%{transform:scale(.3) rotate(-12deg);opacity:0}60%{transform:scale(1.12) rotate(3deg);opacity:1}100%{transform:scale(1) rotate(0)}}`}</style>
  </div>
);

export const BadgeCelebration = ({ enabled }) => {
  const { pathname } = useLocation();
  const [queue, setQueue] = useState([]);

  useEffect(() => {
    if (!enabled || queue.length) return;
    api.get('/gamification/new-badges').then((r) => setQueue(r.data || [])).catch(() => {});
  }, [enabled, pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  const badge = queue[0];
  const next = () => {
    api.post('/gamification/badges-seen', { badge_ids: [badge.id] }).catch(() => {});
    setQueue((q) => q.slice(1));
  };
  if (!badge) return null;
  const tier = badgeTier(badge.id);

  return (
    <Dialog open onOpenChange={(o) => !o && next()}>
      <DialogContent className="max-w-sm overflow-hidden text-center p-8" data-testid="badge-celebration">
        <Confetti />
        <p className="text-xs font-bold tracking-[0.25em] text-[#F37021] uppercase">New badge unlocked</p>
        <div className="mx-auto my-5" style={{ animation: 'badge-pop .7s ease-out both' }}><BadgeShield badge={badge} size="lg" /></div>
        <DialogTitle className="text-2xl font-bold text-[#002B47]" style={{ fontFamily: 'Manrope, sans-serif' }} data-testid="badge-celebration-name">{badge.name}</DialogTitle>
        <p className="text-sm text-slate-500 mt-1">{badge.description}</p>
        <p className="text-xs text-slate-400 mt-1 capitalize">{tier} emblem</p>
        <Button onClick={next} className="mt-6 w-full rounded-full bg-[#F37021] hover:bg-[#D95D0F] text-white" data-testid="badge-celebration-close">
          {queue.length > 1 ? `Next badge (${queue.length - 1} more)` : 'Awesome!'}
        </Button>
      </DialogContent>
    </Dialog>
  );
};
